"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Step_1 = __importDefault(require("../step/Step"));
var React = __importStar(require("react"));
var Styled = __importStar(require("./SteppedHeaderStyles"));
var SteppedHeader = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep, direction = _a.direction, handleStepClick = _a.handleStepClick;
    return (React.createElement(Styled.SteppedHeaderContainer, { direction: direction }, steps.map(function (step) { return (React.createElement(Step_1.default, { key: "step_".concat(step.value), number: step.value, label: step.label, active: step.value === activeStep, isBlocked: step.isBlocked, onClick: function () { return handleStepClick(step.value); } })); })));
};
exports.default = SteppedHeader;
